import { createSelector } from 'reselect';
import type { AllInclusiveServicesData } from 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import 'Store/price-remote/all-inclusive-services/allInclusiveServices.helper';
import { priceRemoteSelector } from 'Store/price-remote/priceRemote.selector';
export const allInclusiveServicesSelector = createSelector(
  priceRemoteSelector,
  ({ allInclusiveServices: { data } }): AllInclusiveServicesData => data,
);
